import React from 'react';
import { shape, string } from 'prop-types';

import './styles.css';

const ErrorMessage = ({ errors, touched, name }) =>{
  return errors[name] && touched[name] ? (
    <div className="error-message">{errors[name]}</div>
  ) : null;
}

ErrorMessage.propTypes = {
  errors: shape({}).isRequired,
  touched: shape({}).isRequired,
  name: string.isRequired,
};

export default ErrorMessage;
